import { Col, FlexView, Row, COLORS } from '@cuemath/comps';
import { Button, Checkbox, Text } from '@cuemath/web-comps';
import React from 'react';
import LAYOUT from 'constants/layout';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const { GUTTER, GAP } = LAYOUT;

const TeacherAttribute = styled(Row)`
  margin: 0 -${GUTTER / 2}px;
  margin-right: ${GUTTER}px;
  margin-bottom: 4px;
`;

const TeacherDetailsWrapper = styled(FlexView)`
  border-radius: 8px;
  border: ${({ selected }) => `1px solid ${COLORS[selected ? 'COLA' : 'GREY_SHADE']}`};
  cursor: pointer;
  margin-bottom: 16px;
  transition: 0.35s ease;

  &:hover {
    box-shadow: 2px 2px 5px 2px rgba(0, 56, 122, 0.15);
    border: 1px solid ${COLORS.COLA};
  }
`;
const ContentWrapper = styled(FlexView)`
  flex: 1;
`;

const TeacherDetails = ({
  id,
  name,
  score,
  enrollments,
  sopScore,
  studentDensity,
  plusPacToPaid,
  basePacToPaid,
  onPress,
  selectedTeacher,
}) => (
  <TeacherDetailsWrapper
    wrap
    flexDirection="row"
    alignItems="center"
    gutter={GAP}
    gap={GAP}
    onClick={() => onPress(id)}
    selected={selectedTeacher === id}
  >
    <ContentWrapper wrap>
      <TeacherAttribute alignItems="center">
        <Col gutter={8}>
          <Text variant="body2">{`Teacher id: `}</Text>
        </Col>
        <Col gutter={0}>
          <Button
            label={id}
            size="small"
            variant="tertiaryWithUnderline"
            onClick={() => window.open(`/users/teachers/${id}`, '_blank')}
          />
        </Col>
      </TeacherAttribute>
      <TeacherAttribute alignItems="center">
        <Col gutter={8}>
          <Text variant="body2">{`Teacher name: `}</Text>
        </Col>
        <Col gutter={0}>
          <Text variant="body1Medium">{name}</Text>
        </Col>
      </TeacherAttribute>
      <Row alignItems="center">
        <Col gutter={0}>
          <TeacherAttribute alignItems="center">
            <Col gutter={8}>
              <Text variant="body2">{`Teacher score: `}</Text>
            </Col>
            <Col gutter={0}>
              <Text variant="body1Medium">{score}</Text>
            </Col>
          </TeacherAttribute>
        </Col>
        <Col gutter={8}>
          <TeacherAttribute alignItems="center">
            <Col gutter={8}>
              <Text variant="body2">{`Enrollments: `}</Text>
            </Col>
            <Col>
              <Text variant="body1Medium">{enrollments}</Text>
            </Col>
          </TeacherAttribute>
        </Col>
        <Col gutter={4}>
          <TeacherAttribute alignItems="center">
            <Col gutter={8}>
              <Text variant="body2">{`SOP score: `}</Text>
            </Col>
            <Col gutter={0}>
              <Text variant="body1Medium">{sopScore}</Text>
            </Col>
          </TeacherAttribute>
        </Col>
      </Row>
      <Row alignItems="center">
        <Col gutter={0}>
          <TeacherAttribute alignItems="center">
            <Col gutter={8}>
              <Text variant="body2">{`Student density: `}</Text>
            </Col>
            <Col gutter={0}>
              <Text variant="body1Medium">{studentDensity}</Text>
            </Col>
          </TeacherAttribute>
        </Col>
        <Col gutter={8}>
          <TeacherAttribute alignItems="center">
            <Col gutter={8}>
              <Text variant="body2">{`BASE PAC to PAID: `}</Text>
            </Col>
            <Col gutter={0}>
              <Text variant="body1Medium">{basePacToPaid}</Text>
            </Col>
          </TeacherAttribute>
        </Col>
        <Col gutter={8}>
          <TeacherAttribute alignItems="center">
            <Col gutter={8}>
              <Text variant="body2">{`PLUS PAC to PAID: `}</Text>
            </Col>
            <Col gutter={0}>
              <Text variant="body1Medium">{plusPacToPaid}</Text>
            </Col>
          </TeacherAttribute>
        </Col>
      </Row>
    </ContentWrapper>
    <FlexView alignItems="flex-end">
      <Checkbox checked={selectedTeacher === id} onChange={() => onPress(id)} />
    </FlexView>
  </TeacherDetailsWrapper>
);

TeacherDetails.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  score: PropTypes.number,
  enrollments: PropTypes.number,
  sopScore: PropTypes.number,
  studentDensity: PropTypes.number,
  plusPacToPaid: PropTypes.number,
  basePacToPaid: PropTypes.number,
  onPress: PropTypes.func,
  selectedTeacher: PropTypes.string,
};

export default TeacherDetails;
